/**
 * One-time admin sign-in codes arrive on /ab-login?code=... (or ?error={fixed code}
 * when the Microsoft sign-in started from this site failed). The code must never be
 * observable by anything that reports the page URL (Google Analytics, Bugsnag,
 * referrer headers on external resources, browser history), so it is captured and
 * scrubbed from the address bar at app startup — before analytics initialize or
 * anything renders — and handed to the /ab-login page exactly once.
 */
let handoffCode: string | null = null;
let handoffError: string | null = null;

export function captureHandoffCode(): void {
    try {
        if(window.location.pathname !== '/ab-login')
            return;
        const query = new URLSearchParams(window.location.search);
        handoffCode = query.get('code');
        handoffError = query.get('error');
        if(handoffCode || handoffError)
            window.history.replaceState(null, '', '/ab-login');
    } catch(e) { }
}

/** Return the captured code (once); subsequent calls return null. */
export function takeHandoffCode(): string | null {
    const code = handoffCode;
    handoffCode = null;
    return code;
}

/** Return the captured sign-in error message (once); subsequent calls return null. */
export function takeHandoffError(): string | null {
    const error = handoffError;
    handoffError = null;
    return error;
}
